import { render, staticRenderFns } from "./EntregaTable.vue?vue&type=template&id=416a9d1f"
import script from "./EntregaTable.vue?vue&type=script&lang=js"
export * from "./EntregaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports